
import React, {Component} from 'react';
import BaseComponent from "../../../../base/BaseComponent";
import ReactAudioPlayer from 'react-audio-player';

export default class DetailAudio extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    initAudio() {
        //创建音频区域
    }

    stop(){

    }

    componentDidMount() {
        this.initAudio()
    }

    render() {
        let {detailData = {}} = this.props;
        let {storageFile = {}} = detailData;
        let {path = ""} = storageFile;
        return (
            <div style={{width: "100%", height: "100%", display: 'flex',justifyContent: 'center',
                alignItems: 'center'}}>
                <ReactAudioPlayer
                    src={path}
                    autoPlay={false}
                    ref={(ref)=>this.reactAudioPlayer=ref}
                    controls
                    controlsList={'nodownload'}
                />
            </div>
        )
    }

}